import classNames from 'classnames';
import React from 'react';

export interface ImageProps {
  src: string;
  alt?: string;
  circle?: boolean;
  rounded?: boolean;
  background?: boolean;
  style?: React.CSSProperties;
}

export const Image = React.memo(
  ({ background, src, alt, circle, rounded, style }: ImageProps) => {
    const imageShape = circle ? 'rounded-full' : rounded ? 'rounded-md' : '';
    return background ? (
      <div
        className={classNames('w-full bg-cover bg-top h-full', imageShape)}
        style={{ backgroundImage: `url(${src})` }}
      />
    ) : (
      <img
        className={classNames('w-full h-full', imageShape)}
        src={src}
        alt={alt || src}
        style={style}
      />
    );
  }
);

Image.displayName = 'Image';
